/* Wishlist: heart on every product card + on the product page. Saved on the phone (no login needed). */
(function () {
  var cfg = window.nvShop || {};
  if (cfg.wishlist === false || !window.NvCore) return;
  var C = window.NvCore, KEY = 'nv_wishlist_v1';

  function read() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, 100))); } catch (e) { /* private mode */ }
    document.dispatchEvent(new CustomEvent('nv:wishlist', { detail: a }));
  }
  var WL = {
    list: read,
    has: function (h) { return read().indexOf(h) > -1; },
    toggle: function (h) { var a = read(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.unshift(h); write(a); return i === -1; },
    remove: function (h) { write(read().filter(function (x) { return x !== h; })); },
    clear: function () { write([]); }
  };
  window.NvWishlist = WL;

  var HEART = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.6-9.2C.9 8.4 2.7 5 6 5c2 0 3.4 1.1 4.2 2.4h3.6C14.6 6.1 16 5 18 5c3.3 0 5.1 3.4 3.6 6.8C19.5 16.4 12 21 12 21z"/></svg>';

  function paint(b) {
    var on = WL.has(b.getAttribute('data-handle'));
    b.classList.toggle('is-on', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
  }
  function make(handle, extra) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'nv-heart' + (extra ? ' ' + extra : '');
    b.setAttribute('data-handle', handle);
    b.innerHTML = HEART;
    paint(b);
    return b;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.nv-heart');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var added = WL.toggle(b.getAttribute('data-handle'));
    b.classList.remove('pop'); void b.offsetWidth; if (added) b.classList.add('pop');
    if (navigator.vibrate) navigator.vibrate(10);
    var url = cfg.wishlistUrl || '/pages/wishlist';
    C.toast(added ? 'Saved to your wishlist &middot; <a href="' + C.esc(url) + '">View</a>' : 'Removed from your wishlist');
  }, true);

  function syncAll() { document.querySelectorAll('.nv-heart').forEach(paint); }
  document.addEventListener('nv:wishlist', syncAll);
  window.addEventListener('storage', function (e) { if (e.key === KEY) syncAll(); });
  window.addEventListener('pageshow', syncAll);

  function scan() {
    // product page: heart over the main gallery
    var gal = document.querySelector('media-gallery');
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (gal && m && !gal.querySelector('.nv-heart--pdp')) {
      if (getComputedStyle(gal).position === 'static') gal.style.position = 'relative';
      gal.appendChild(make(decodeURIComponent(m[1]), 'nv-heart--pdp'));
    }
    // every product card
    document.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (a.__nvH) return; a.__nvH = 1;
      if (a.closest(C.EXCLUDE)) return;
      var hit = C.findCard(a);
      if (!hit || hit.card.__nvHeart || hit.card.closest(C.EXCLUDE)) return;
      var handle = C.handleOf(hit.link.href), im = hit.card.querySelector('img');
      if (!handle || !im) return;
      var host = im.closest('[class*="image-wrapper-"], .card__media, .media');
      if (!host || !hit.card.contains(host)) host = im.parentElement;
      if (!host) return;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative'; // only if it was not positioned already
      host.appendChild(make(handle));
      hit.card.__nvHeart = 1;
    });
  }
  var t;
  function later() { clearTimeout(t); t = setTimeout(scan, 150); }
  function boot() {
    scan();
    new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
